"use strict";

module.exports = function () {
  return Math.ceil(this.count / this.limit);
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/computed/total-pages.js